<!-- View DialogIssueExternalCouponSuccess -->
<template>
  <ItemDialog ref="issueExternalCouponSuccess" image-type="coupon">
    <template #content-area>
      <div class="text-caution">
        <h1>
          <strong>クーポンが付与されました</strong>
        </h1>
      </div>
      <div class="text-center">
        <p>クーポン一覧ページよりご確認下さい。</p>
      </div>
    </template>
    <template v-if="isShowButtonsForPurchaseSuccess" #button-area>
      <ItemButton
        label="クーポン一覧ページへ"
        action-type="btn-primary"
        @clicked="gotoExternalCouponTab()"
      />
      <ItemButton
        label="キャンセル"
        action-type="btn-cancel"
        @clicked="closeDialog"
      />
    </template>
    <template v-else #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-cancel"
        @clicked="closeDialog"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DialogIssueExternalCouponSuccess",
  props: {
    openCouponVersionWarning: {
      type: Function,
    },
    isNotTargetVersion: {
      type: Boolean,
    },
  },
  setup(props) {
    const issueExternalCouponSuccess = ref(null);
    const isShowButtonsForPurchaseSuccess = ref(true);

    const openDialog = (isPurchaseSuccess) => {
      isShowButtonsForPurchaseSuccess.value = isPurchaseSuccess;
      issueExternalCouponSuccess.value.open();
    };

    const closeDialog = () => {
      issueExternalCouponSuccess.value.close();
    };

    const gotoExternalCouponTab = () => {
      if (props.isNotTargetVersion && props.openCouponVersionWarning) {
        props.openCouponVersionWarning();
      } else {
        console.log(
          "DialogIssueExternalCouponSuccess ::> gotoExternalCouponTab"
        );
        nativeHandlerService.ncOpenExternalCouponIndex();
      }
    };

    return {
      issueExternalCouponSuccess,
      openDialog,
      closeDialog,
      gotoExternalCouponTab,
      isShowButtonsForPurchaseSuccess,
    };
  },
};
</script>

<style scoped lang="scss">
.text-center {
  text-align: center;
  font-size: 3vw;
}

.text-caution {
  text-align: center;
  margin-bottom: 1.5rem;
  font-weight: bold;
  font-size: 4vw !important;
}
</style>
